<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="empty-search-message-container">
    <div class="empty-search-message" v-html="message"></div>
  </div>
</template>

<script>
export default {
  name: 'EcsEmptySearchMessage',

  props: {
    message: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped lang="scss">
.empty-search-message-container {
  padding: 20px 16px;
}

.empty-search-message {
  max-width: 80ch;
  min-width: 400px;

  background-color: var(--v-surface-darken1, #222);
  padding: 32px;
  border-radius: 4px;
  text-align: center;
  margin: 0 auto;
  color: #f2f2f2f2;
}
</style>

<style lang="scss">
.empty-search-message b {
  color: var(--v-primary-base) !important;
}
</style>
